'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var _shops = require('redux/modules/shops');

var shopActions = _interopRequireWildcard(_shops);

var _reactRedux = require('react-redux');

var _support = require('helpers/support');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HomeService = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    submit: state.shops.submit,
    SERVICE_OF_HOME_SERVICE: state.shops.SERVICE_OF_HOME_SERVICE
  };
}, {
  loadServiceOfHomeService: shopActions.loadServiceOfHomeService,
  resetShopDetail: shopActions.resetShopDetail,
  getShopData: shopActions.getShopData
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(HomeService, _Component);

  function HomeService() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, HomeService);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = HomeService.__proto__ || (0, _getPrototypeOf2.default)(HomeService)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showModalAlert: false
    }, _this.handleCloseModalAlert = function (value) {
      _this.setState({ showModalAlert: value });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(HomeService, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (_support.Helper.isDev()) {
        this.props.getShopData('lookme-spa-4-freelancer');
        this.props.loadServiceOfHomeService('5f1a6ab8f959150024d1ca07');
      } else {
        this.props.getShopData('lookme-dv-tai-nha');
        this.props.loadServiceOfHomeService('5f34e25fd40e73001f1d2226');
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.resetShopDetail();
    }
  }, {
    key: 'renderAllService',
    value: function renderAllService(service, i) {
      var _this2 = this;

      var bookingServices = this.props.submit.bookingServices;

      return _react2.default.createElement(
        _reactBootstrap.Col,
        { md: 3, key: 'voucherCard_' + i },
        _react2.default.createElement(_components.ServiceItem, {
          key: 'serviceItem_' + i,
          active: bookingServices[0] && bookingServices[0]._id === service._id,
          item: service,
          onDescription: function onDescription() {
            return _this2.setState({ showModalAlert: true });
          }
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var styles = require('./HomeService.scss');
      var showModalAlert = this.state.showModalAlert;
      var dataService = this.props.SERVICE_OF_HOME_SERVICE.data;

      return _react2.default.createElement(
        'div',
        { className: styles.HomeService + ' container' },
        _react2.default.createElement(_components.HelmetSEO, { path: 'dich-vu-tai-nha' }),
        _react2.default.createElement(
          'div',
          { className: styles.header },
          _react2.default.createElement('div', { className: styles.borderHighlight }),
          _react2.default.createElement(
            'div',
            { className: styles.title },
            'D\u1ECBch v\u1EE5 t\u1EA1i nh\xE0'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.listVoucher },
          !!(dataService && dataService.length) ? _react2.default.createElement(
            _reactBootstrap.Row,
            null,
            dataService.map(function (service, i) {
              return _this3.renderAllService(service, i);
            })
          ) : _react2.default.createElement(
            'div',
            { className: styles.nodata },
            'Hi\u1EC7n t\u1EA1i ch\u01B0a c\xF3 khuy\u1EBFn m\xE3i n\xE0o!'
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            show: showModalAlert,
            onHide: this.handleCloseModalAlert,
            className: 'modal-alert-login',
            backdrop: true
          },
          _react2.default.createElement(
            'div',
            { className: styles.modalAlert },
            _react2.default.createElement(
              'div',
              { className: styles.headerAlert },
              'Th\xF4ng b\xE1o'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.contentAlert },
              'Vui l\xF2ng truy c\u1EADp b\u1EB1ng \u0111i\u1EC7n tho\u1EA1i \u0111\u1EC3 s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 t\u1EA1i nh\xE0'
            ),
            _react2.default.createElement(
              'div',
              {
                className: styles.btnLogin,
                onClick: function onClick() {
                  return _this3.handleCloseModalAlert(false);
                }
              },
              'OK'
            )
          )
        )
      );
    }
  }]);
  return HomeService;
}(_react.Component), _class2.propTypes = {
  params: _react.PropTypes.object,
  submit: _react.PropTypes.object,
  SERVICE_OF_HOME_SERVICE: _react.PropTypes.object,
  // function
  loadServiceOfHomeService: _react.PropTypes.func,
  resetShopDetail: _react.PropTypes.func,
  getShopData: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = HomeService;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/HomeService/HomeService.js
// module id = 1676
// module chunks = 0